// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1lgvI","row":"styles_row__1akcb","identifier":"styles_identifier__3LmZg"};